/* eslint-disable */
// ComposerEmailToggle — "Also send by email", the per-send decision that sits on
// top of the per-type one (§6.4).
//
// Its own file because AnnouncementComposer is at the 300-line cap and because
// the control owns a real rule, not just a checkbox: which of the four severity
// levels can be overridden at all. Keeping that rule beside the input means the
// composer never has to re-derive it.
//
// ⚠️ THREE STATES, NOT TWO. `choice` is null until somebody touches the control,
// and null is meaningful: it means "use the type's setting", which the composer
// expresses by omitting `email` from the payload entirely. A checkbox that
// defaulted to false would silently turn email OFF for every announcement whose
// sender never looked at it.
//
// ⚠️ THE LOCK IS THE DATABASE'S, NOT THIS FILE'S. nt_silent_never_mails and
// nt_critical_always_mails are CHECK constraints; a disabled input is a courtesy
// on top of a rule that is already enforced. So the reason is rendered on the
// row, where the person about to press Send can read it, rather than in a
// tooltip they would have to go looking for.

import React from 'react';
import { useTypeEmailPolicy } from '../../hooks/useTypeEmailPolicy';
import styles from './composer.module.css';

export default function ComposerEmailToggle({ typeKey, choice, onChoice }) {
  const policy = useTypeEmailPolicy(typeKey);
  const locked = policy.alwaysMails || policy.neverMails;

  // An explicit choice wins; otherwise the type's own setting. critical always
  // mails and silent never does, whatever the column happens to say.
  const on = policy.alwaysMails ? true
    : policy.neverMails ? false
    : choice !== null && choice !== undefined ? choice
    : policy.emailEnabled === true;

  return (
    <label className={styles.emailRow} data-test="composer-email-row">
      <input
        type="checkbox"
        className={styles.emailBox}
        checked={on}
        disabled={locked || policy.loading}
        onChange={(e) => onChoice(e.target.checked)}
        data-test="composer-email"
      />
      <span className={styles.emailText}>
        Also send by email
        {policy.reason && (
          <span className={styles.emailWhy} data-test="composer-email-why">
            {policy.reason}
          </span>
        )}
      </span>
    </label>
  );
}
